import React from "react";
import { ApolloConsumer } from "@apollo/client";
import { DELETE_FORM } from "./genericQueries";
import Button from "../SimpleForm/UI/Button";
import { UPDATE_FORM_790_LOOKUP } from "./Form9142A/queries";

const handleDelete = async (
  client,
  application_id,
  formType,
  history,
  values,
  group_role
) => {
  if (formType === "9142A" && values && values["e3_is_job_order_complete"]) {
    await client.mutate({
      mutation: UPDATE_FORM_790_LOOKUP,
      variables: {
        Form790LookupUpdateInput: {
          LinkedForm9142ANumber: application_id,
          caseNumberFor790A: values["e3_is_job_order_complete"],
          islinked: false,
          caseOwner: "deletingCase",
        },
      },
    });
  }
  const response = await client.mutate({
    mutation: DELETE_FORM,
    variables: { id: application_id, FormType: formType },
  });
  if (response.data && response.data.deleteForm === 200) {
    return history.push(`/dashboard/application/`);
  } else {
    return console.error("We could not delete the form", response);
  }
};

const renderDeleteButton = (
  application_id,
  formType,
  history,
  values,
  group_role
) => {
  return (
    <ApolloConsumer>
      {(client) => (
        <Button
          type="button"
          coloring="alert-fill"
          onClick={() =>
            handleDelete(
              client,
              application_id,
              formType,
              history,
              values,
              group_role
            )
          }
        >
          Yes, delete this case
        </Button>
      )}
    </ApolloConsumer>
  );
};

export default renderDeleteButton;
